import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import {map, Observable, merge, catchError, throwError} from 'rxjs';
import {environment} from "../../environments/environment";
import { MaintenanceDestinatario } from "../models/MaintenanceDestinatario";
import {FabFilterDescriptor} from "@fabric/components/table-filter/data-query";
import {PagedResponse} from "../models/PagedResponse";
import {PagedRequest} from "../models/PagedRequest";
import {MaintenanceTransportistaLite} from "../models/MaintenanceTransportistaLite";


@Injectable({
    providedIn: 'root'
})


export class DestinatarioService {

    private url = "";
    private apiEndpoint = environment.destApiEndpoint;

    constructor(private readonly httpClient:HttpClient) { }

    getDestinatariotable(): Observable<MaintenanceDestinatario[]> {
        this.url = this.apiEndpoint;
        console.log(this.url);
        return this.httpClient.get<MaintenanceDestinatario[]>(this.url).pipe(
          map((res) => {
            return res.map((dest) => {
              return MaintenanceDestinatario.transformDestinatario(dest);
            })
          })
        );
    }

    getDestinatarioLiteTable(): Observable<MaintenanceTransportistaLite[]> {
      this.url = `${this.apiEndpoint}/lite`;
      console.log(this.url);
      return this.httpClient.get<MaintenanceTransportistaLite[]>(this.url);
    }

    addUpdateUser(destinatario: MaintenanceDestinatario, add: boolean): Observable<MaintenanceDestinatario> {
        console.log("processing...");
        console.log(destinatario);
        if (add) {
          return this.addUser(destinatario);
        } else {
          return this.updateUser(destinatario);
        }
      }

      addUser(destinatario: MaintenanceDestinatario): Observable<MaintenanceDestinatario> {
        this.url = this.apiEndpoint;
        console.log(this.url);
        return this.httpClient.post<MaintenanceDestinatario>(this.url, destinatario).pipe(
          map((res: any) => {
            return MaintenanceDestinatario.transformDestinatario(res);
          }),
          catchError((err: any) => {
            console.log("Saving failed for destinatario: " + destinatario);
            return throwError(err);
          })
        );
      }

      updateUser(destinatario: MaintenanceDestinatario): Observable<MaintenanceDestinatario> {
        this.url = this.apiEndpoint;
        console.log(this.url);
        return this.httpClient.put<MaintenanceDestinatario>(this.url, destinatario).pipe(
          map((res: any) => {
            return MaintenanceDestinatario.transformDestinatario(res);
          }),
          catchError((err: any) => {
            console.log("Saving failed for destinatario: " + destinatario);
            console.log(destinatario);
            return throwError(err);
          })
        );
      }

      getPage(
        page: number,
        pageSize: number,
        sortFields: string[],
        sortDirection: 'asc' | 'desc' | '',
        filters: FabFilterDescriptor[]
      ): Observable<PagedResponse<MaintenanceDestinatario>> {
        const req = new PagedRequest();
        req.page = page;
        req.pageSize = pageSize;
        req.sortFields = sortFields;
        req.sortDirection = sortDirection;
        req.filters = filters;

        return this.httpClient.post<PagedResponse<MaintenanceDestinatario>>(this.apiEndpoint + "/pagination_destinatario", req)
          .pipe(
            map((a: PagedResponse<MaintenanceDestinatario>) => {
              a.data = a.data.map(e => MaintenanceDestinatario.transformDestinatario(e));
              return a;
            })
          );
      }
}
